import React from 'react'
import { Box, Typography } from '@material-ui/core'
import {
  CalendarTodayOutlined,
  AccountBalanceWalletOutlined,
  MonetizationOnOutlined,
  NewReleasesOutlined,
  LocalOfferOutlined,
} from '@material-ui/icons'
import helpers from 'helpers'

const ItemSettings = ({ icon, title, value }) => {
  return (
    <Box p={2} textAlign="center" width={{ xs: '50%', sm: '200px' }}>
      <Typography>{icon}</Typography>
      <Box mt={1}>
        <Typography color="textSecondary">{title}</Typography>
        <Typography component="div" color="textSecondary">
          <Box fontWeight="fontWeightBold">{value}</Box>
        </Typography>
      </Box>
    </Box>
  )
}

const PlanSettings = ({ plan }) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent={{ xs: 'center', sm: 'flex-start' }}
      mt={1}
    >
      <ItemSettings
        icon={<CalendarTodayOutlined color="primary" fontSize="large" />}
        title="Periodicidade"
        value={helpers.plans.formatPeriodicity(plan.periodicity)}
      />
      <ItemSettings
        icon={<AccountBalanceWalletOutlined color="primary" fontSize="large" />}
        title="Cobranças"
        value={plan.quantity === 0 ? 'Recorrente' : plan.quantity}
      />
      <ItemSettings
        icon={<MonetizationOnOutlined color="primary" fontSize="large" />}
        title="Valor de cada cobrança"
        value={helpers.currency(plan.price)}
      />
      <ItemSettings
        icon={<NewReleasesOutlined color="primary" fontSize="large" />}
        title="Cobranças com desconto"
        value={
          plan.contractPlanEntries[0]
            ? plan.contractPlanEntries[0].quantity === 0
              ? 'Recorrente'
              : plan.contractPlanEntries[0].quantity
            : 'Nenhum'
        }
      />
      <ItemSettings
        icon={<LocalOfferOutlined color="primary" fontSize="large" />}
        title="Valor do desconto"
        value={
          plan.contractPlanEntries[0]?.price
            ? helpers.currency(plan.contractPlanEntries[0].price)
            : '-'
        }
      />
    </Box>
  )
}

export default PlanSettings
